/* eslint-disable react/prop-types */
// Imports
import React from "react";
import closeCross from "src/files/cross.svg";

function RecShareModal({ isModalOpen, onModalClose }) {
  return (
    <>
      {isModalOpen && (
        <dialog className="rec-share-modal">
          <div className="rec-share-modal__container">
            <button
              className="rec-share-modal__close-button"
              onClick={onModalClose}
            >
              <img
                className="rec-share-modal__icon-cross"
                src={closeCross}
                alt=""
              />
            </button>
            <h2 className="rec-share-modal__title">Share my recommendations</h2>
            <p className="rec-share-modal__desc">Some description</p>
            <div className="rec-share-modal__link-wrapper">
              <div className="rec-share-modal__link">Link 1</div>
              <div className="rec-share-modal__link">Link 2</div>
            </div>
          </div>
        </dialog>
      )}
    </>
  );
}

export default RecShareModal;
